import mixpanel from 'mixpanel-browser';
import { getEnvVariable } from './get-env-variable';
import { MixpanelEventParams, MixpanelEvents } from '../contracts';
import { getSessionToken } from './get-session-token';

const mixPanelId = '36bc8102bd15fc0a7471651e632a1c1d';
// Percentage of checkout sessions to sample for Mixpanel Session Replay (ACDEV-24904).
// Rollout is gated by the enable_mixpanel_session_recording feature flag — when the
// flag is on we record 100% of sessions; the flag itself is the sampling lever.
const SESSION_REPLAY_SAMPLE_PERCENT = 100;

let isMixpanelInitialized = false;

export interface InitProductEventsOptions {
  enableSessionReplay?: boolean;
}

export const initProductEventsService = ({
  enableSessionReplay = false,
}: InitProductEventsOptions = {}) => {
  if (isMixpanelInitialized) {
    return;
  }

  const mixpanelToken = getEnvVariable('REACT_APP_MIXPANEL_TOKEN', mixPanelId);
  if (!mixpanelToken) {
    console.warn('Mixpanel: REACT_APP_MIXPANEL_TOKEN not configured');
    return;
  }

  try {
    mixpanel.init(mixpanelToken, {
      api_host: 'https://api-eu.mixpanel.com',
      debug: getEnvVariable('REACT_APP_ENV') !== 'production',
      track_pageview: true,
      persistence: 'localStorage',
      // Mixpanel's native sampling: rolls Math.random() * 100 <= percent at init (ACDEV-24904).
      record_sessions_percent: enableSessionReplay ? SESSION_REPLAY_SAMPLE_PERCENT : 0,
      record_block_selector: 'video, audio',
    });
    isMixpanelInitialized = true;
  } catch (error) {
    console.error('Failed to initialize Mixpanel:', error);
    return;
  }
  const session_id = getSessionToken();
  if (!session_id) {
    return;
  }
  try {
    mixpanel.identify(session_id);
  } catch (error) {
    console.error('Failed to identify Mixpanel:', error);
  }
};

export const sendMixpanelEvent = (
  eventType: MixpanelEvents,
  params: Partial<MixpanelEventParams>,
) => {
  if (!isMixpanelInitialized) {
    return;
  }

  const session_id = getSessionToken();
  const properties = {
    ...params,
    environment: getEnvVariable('REACT_APP_ENV', process.env.REACT_APP_ENV) || 'local',
    session_id,
    checkout_type: 'V2',
  };
  try {
    mixpanel.track(eventType, properties);
  } catch (error) {
    console.error(error);
  }
};
